module.exports = __webpack_public_path__ + "img/16l006-10.ce6feb09.png";